<div class="root-wrapper">

    <div class="fixed-top">
        <app-global-header></app-global-header>
    </div>

    <div class="space-80"></div>

    <router-outlet></router-outlet>
</div>